/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * List to be used by the spreadsheet editor in the frontend to get the different templates
 * @export
 * @interface TemplatePath
 */
export interface TemplatePath {
    /**
     * Name of the template
     * @type {string}
     * @memberof TemplatePath
     */
    name: string;
    /**
     * Path to download the template
     * @type {string}
     * @memberof TemplatePath
     */
    path: string;
    /**
     * Name of the file presented to the user
     * @type {string}
     * @memberof TemplatePath
     */
    fileName: string;
}

/**
 * Check if a given object implements the TemplatePath interface.
 */
export function instanceOfTemplatePath(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "path" in value;
    isInstance = isInstance && "fileName" in value;

    return isInstance;
}

export function TemplatePathFromJSON(json: any): TemplatePath {
    return TemplatePathFromJSONTyped(json, false);
}

export function TemplatePathFromJSONTyped(json: any, ignoreDiscriminator: boolean): TemplatePath {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'path': json['path'],
        'fileName': json['fileName'],
    };
}

export function TemplatePathToJSON(value?: TemplatePath | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'path': value.path,
        'fileName': value.fileName,
    };
}

